export enum BannerHeightEnum {
  ONE_LINER = '48px',
  TWO_LINER = '96px',
  ONE_LINER_MOBILE = '28px',
  TWO_LINER_MOBILE = '56px',
}
